import { h } from 'preact';
import PureComponent from './PureComponent';
import getJSON from '../utils/get-json';
import { select, scaleLinear } from "d3";

class DistrictMapMini extends PureComponent {
  constructor() {
    super();

    this.state = {};
  }

  drawLegend() {
    const { geometry, mapWidth } = this.props;
    const office = geometry.properties.stats.office;
    const district = geometry.properties.district;
    const id = `district-map__legend__${office}__${district}`

    const svg = select(`#${id}`).select('svg');

  }

  componentDidMount() {
    this.drawLegend();
  }

  componentDidUpdate(prevProps) {

  }

  render() {
    const { geometry, width } = this.props;
    const office = geometry.properties.stats.office;
    const district = geometry.properties.district;
    const id = `district-map__legend__${office}__${district}`

    const padding = 30;

    const stats = geometry.properties.stats;
    const m = stats['2020_margin'];
    const w = stats['2020_winner'];
    const text = `+${Math.abs(Math.round(m * 10) / 10)} ${w}`

    const xScale = scaleLinear()
      .domain([-100, 100])
      .range([
        (width - (width - padding)) / 2,
        (width) - ((width - (width - padding)) / 2)
      ])

    const colorScale = scaleLinear()
      .domain([-100, 0, 100])
      .range(["#1675b0", "white", "#d64946"])

    return (
      <div id={id} class="district-map__legend__gradient">
        <svg
          width={width}
          height={40}
        >
          <defs>
            <linearGradient id="red-white-blue">
              <stop offset="0%" stop-color="#1675b0"></stop>
              <stop offset="50%" stop-color="white"></stop>
              <stop offset="100%" stop-color="#d64946"></stop>
            </linearGradient>
          </defs>
          <rect
            x={(width - (width - padding)) / 2}
            y={25}
            width={width - padding}
            height={13.5}
            fill="url(#red-white-blue)"
          ></rect>
          <g
            transform={`translate(${xScale(m)}, 10)`}
          >
            <polygon
              transform={`translate(0, 15)`}
              points="0,0 -5,-8.5 5,-8.5"
              // fill={colorScale(m)}
              // fill={w == "Trump" ? "#d64946" : "#1675b0"}
              fill="black"
              stroke-width={0}
            ></polygon>
            <text
              text-anchor="middle"
              fill={w == "Trump" ? "#d64946" : "#1675b0"}
            >{text}</text>
          </g>
        </svg>
      </div>
    );
  }
}


export default DistrictMapMini;